var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2.75H9.5C9.5 1.92157 8.82845 1.25 8 1.25C7.17155 1.25 6.5 1.92157 6.5 2.75ZM5.375 2.75C5.375 1.30025 6.55025 0.125 8 0.125C9.44975 0.125 10.625 1.30025 10.625 2.75H14.9375C15.2481 2.75 15.5 3.00184 15.5 3.3125C15.5 3.62316 15.2481 3.875 14.9375 3.875H13.9482L13.0692 12.9584C12.9297 14.4001 11.7181 15.5 10.2697 15.5H5.73027C4.2819 15.5 3.07036 14.4001 2.93085 12.9584L2.05181 3.875H1.0625C0.751842 3.875 0.5 3.62316 0.5 3.3125C0.5 3.00184 0.751842 2.75 1.0625 2.75H5.375ZM6.875 6.3125C6.875 6.00184 6.62315 5.75 6.3125 5.75C6.00184 5.75 5.75 6.00184 5.75 6.3125V11.9375C5.75 12.2482 6.00184 12.5 6.3125 12.5C6.62315 12.5 6.875 12.2482 6.875 11.9375V6.3125ZM9.6875 5.75C9.99815 5.75 10.25 6.00184 10.25 6.3125V11.9375C10.25 12.2482 9.99815 12.5 9.6875 12.5C9.37685 12.5 9.125 12.2482 9.125 11.9375V6.3125C9.125 6.00184 9.37685 5.75 9.6875 5.75ZM4.05062 12.85C4.13433 13.715 4.86125 14.375 5.73027 14.375H10.2697C11.1387 14.375 11.8656 13.715 11.9493 12.85L12.8179 3.875H3.18206L4.05062 12.85Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.178e83b858fc95201adaec26c8376135.svg";
export { ForwardRef as ReactComponent };